export default {
      id: "oc-res-health-check-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-health-check",
      toString: function () {
        return this.url;
      }
    }